(()=>{'use strict';const root=document.querySelector('.arx-root'),config=document.getElementById('arx-config');if(!root||!config)return;const cfg=JSON.parse(config.textContent),$=(s)=>root.querySelector(s),$$=(s)=>[...root.querySelectorAll(s)],pdp='/products/'+cfg.handle,covered=['aera-ergonomic-orthopedic-cushion-pro','aera-ergonomic-seat-cushion'];let busy=false,cart=null,lastFocus=null,scrollY=0;const drawer=$('#arx-cart'),zoom=$('#arx-zoom'),qty=$('#arx-qty'),form=$('#arx-product-form');const money=n=>new Intl.NumberFormat(document.documentElement.lang||'en',{style:'currency',currency:cart?.currency||cfg.currency||'USD'}).format(n/100);const esc=s=>String(s??'').replace(/[&<>"']/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));const isService=i=>[cfg.protection,cfg.legacyProtection].includes(i.variant_id),coverageCount=c=>c.items.filter(i=>covered.includes(i.handle)).reduce((n,i)=>n+i.quantity,0);const route=s=>(cfg.root||'/').replace(/\/$/,'')+s;








async function call(path,body){const res=await fetch(route(path),{method:body?'POST':'GET',headers:{'Content-Type':'application/json','Accept':'application/json'},...(body?{body:JSON.stringify(body)}:{})});let data;try{data=await res.json();}catch(_){throw Error('Your bag could not be updated. Please refresh and try again.');}if(!res.ok)throw Error(data.description||data.message||'Unable to update your bag. Please try again.');return data;}








function lock(yes){busy=yes;$$('#arx-product-form button,.arx-sticky button,#arx-cart button,#arx-cart input').forEach(e=>e.disabled=yes);}








function error(e){['#arx-cart-error','#arx-form-error'].forEach(s=>{const target=$(s);if(target)target.textContent=e?e.message||String(e):'';});}








async function syncCoverage(c){const n=coverageCount(c),services=c.items.filter(isService);if(!services.length)return c;const primary=services.find(i=>i.variant_id===cfg.protection),updates={};for(const i of services){const wanted=i===primary?n:0;if(i.quantity!==wanted)updates[i.key]=wanted;}if(Object.keys(updates).length)c=await call('/cart/update.js',{updates});if(n&&!primary){await call('/cart/add.js',{items:[{id:cfg.protection,quantity:n,properties:{_acp_protection:'true'}}]});c=await call('/cart.js');}return c;}








function guarantee(i){if(['aera-bronoir-skin-pro-with-copper','aera-bronoir-complete-offer','aera-bronoir-skinpro-insoles','aera-bronoir-mystery-gift'].includes(i.handle))return '<a href="/pages/aera-bronoir-returns">30-day return terms · Offer exclusions apply</a>';if(i.handle===cfg.handle)return '<a href="'+cfg.returnUrl+'">90-day return window · Terms</a>';if(i.handle===covered[0])return '<a href="/pages/acp-return-policy">60-day coverage · Terms</a>';if(i.handle===covered[1])return '30-Day Money-Back Guarantee';return '';}








function shortName(i){if(i.handle===cfg.handle)return 'AERA ReliveX Adaptive Correction System';if(i.handle===covered[0])return 'Orthopedic Cushion Pro';if(i.handle===covered[1])return 'Lumbar Support Seat Cushion';return i.product_title;}








function render(c){cart=c;const physical=c.items.filter(i=>!isService(i));$$('[data-arx-count]').forEach(e=>e.textContent=physical.reduce((n,i)=>n+i.quantity,0));$('#arx-cart-lines').innerHTML=physical.length?physical.map(i=>`<article class="arx-line"><img src="${esc(i.image||'')}" width="72" height="72" alt="${esc(i.product_title)}"><div><div class="arx-line-top"><h3>${esc(shortName(i))}</h3><button class="arx-remove" type="button" data-key="${esc(i.key)}" data-quantity="0" aria-label="Remove ${esc(shortName(i))}">×</button></div>${i.variant_title&&i.variant_title!=='Default Title'?`<p class="arx-line-meta">${esc(i.variant_title)}</p>`:''}<p class="arx-line-meta">${guarantee(i)}</p><div class="arx-line-bottom"><div class="arx-counter"><button type="button" data-key="${esc(i.key)}" data-quantity="${Math.max(0,i.quantity-1)}" aria-label="Decrease quantity">−</button><span>${i.quantity}</span><button type="button" data-key="${esc(i.key)}" data-quantity="${i.quantity+1}" aria-label="Increase quantity">+</button></div><span style="text-align:right">${i.handle===cfg.handle?`<small style="display:block;color:#7a8588"><s>${money(20000*i.quantity)}</s> · SAVE 60%</small>`:''}<strong>${money(i.final_line_price)}</strong></span></div>${i.line_level_discount_allocations?.length?`<p class="arx-line-meta">${i.line_level_discount_allocations.map(d=>esc(d.discount_application.title)).join(' · ')}</p>`:''}</div></article>`).join(''):'<p>Your bag is empty.</p>';const n=coverageCount(c),services=c.items.filter(isService),selected=services.reduce((a,i)=>a+i.quantity,0);$('#arx-coverage').innerHTML=n?`<label class="arx-coverage-row"><span><strong>Fast Shipping & Protection</strong><br>Optional · ${money(399)} per cushion</span><input id="arx-protection" type="checkbox" ${selected?'checked':''}></label><p class="arx-coverage-note">Cushions only: ${n} × ${money(399)} = ${money(n*399)}${selected?' selected':''}. ReliveX is excluded. <a href="/pages/acp-shipping-policy#protection">Terms</a></p>`:'';$('#arx-subtotal').textContent=money(c.total_price);$('#arx-checkout-total').textContent=money(c.total_price);$('#arx-savings').innerHTML=c.total_discount?`Discount savings <strong>−${money(c.total_discount)}</strong>`:'';$('#arx-savings').hidden=!c.total_discount;$('#arx-checkout').disabled=!physical.length||busy;}








async function run(fn){if(busy)return;error(null);lock(true);try{const c=await fn();render(await syncCoverage(c||await call('/cart.js')));}catch(e){try{render(await call('/cart.js'));}catch(_){}error(e);}finally{lock(false);if(cart&&!cart.items.some(i=>!isService(i)))$('#arx-checkout').disabled=true;}}








function sticky(){const e=$('.arx-sticky');if(e)e.hidden=!!drawer.open||!!zoom.open||!form||form.getBoundingClientRect().bottom>0;}








function openDialog(d){lastFocus=document.activeElement;scrollY=window.scrollY;document.documentElement.style.overflow='hidden';d.showModal();sticky();d.querySelector('button')?.focus();}








function closeDialog(d){d.close();document.documentElement.style.overflow='';lastFocus?.focus();sticky();}








$$('dialog').forEach(d=>{d.addEventListener('cancel',e=>{e.preventDefault();closeDialog(d);});d.addEventListener('click',e=>{if(e.target===d){const b=d.getBoundingClientRect();if(e.clientX<b.left||e.clientX>b.right||e.clientY<b.top||e.clientY>b.bottom)closeDialog(d);}});d.addEventListener('keydown',e=>{if(e.key!=='Tab')return;const a=[...d.querySelectorAll('button:not(:disabled),a[href],input:not(:disabled)')].filter(n=>n.offsetParent!==null);if(!a.length)return;if(e.shiftKey&&document.activeElement===a[0]){a.at(-1).focus();e.preventDefault();}else if(!e.shiftKey&&document.activeElement===a.at(-1)){a[0].focus();e.preventDefault();}});});








root.addEventListener('click',async e=>{const close=e.target.closest('[data-arx-close]');if(close){closeDialog(close.closest('dialog'));return;}if(e.target.closest('[data-arx-bag]')){openDialog(drawer);await run(()=>call('/cart.js'));return;}const change=e.target.closest('[data-key]');if(change){await run(()=>call('/cart/change.js',{id:change.dataset.key,quantity:Number(change.dataset.quantity)}));return;}const image=e.target.closest('[data-arx-image]');if(image){$('#arx-main-image').src=image.dataset.arxImage;$$('[data-arx-image]').forEach(b=>b.setAttribute('aria-pressed',String(b===image)));return;}if(e.target.closest('[data-arx-zoom]')){zoom.querySelector('img').src=$('#arx-main-image').src;openDialog(zoom);return;}if(e.target.closest('[data-arx-sticky-atc]')){form?.requestSubmit();return;}if(e.target.closest('#arx-more-reviews')){const hidden=$$('[data-arx-review][hidden]');hidden.slice(0,6).forEach(r=>r.hidden=false);if(hidden.length<=6)e.target.hidden=true;return;}if(e.target.closest('#arx-checkout')){if(busy)return;await run(()=>call('/cart.js'));if(!$('#arx-cart-error').textContent&&cart?.items.some(i=>!isService(i)))location.href=route('/checkout');}});








root.addEventListener('change',async e=>{if(e.target.id!=='arx-protection')return;const selected=e.target.checked;await run(async()=>{let c=await call('/cart.js');if(selected){const n=coverageCount(c);if(n&&!c.items.some(isService)){await call('/cart/add.js',{items:[{id:cfg.protection,quantity:n,properties:{_acp_protection:'true'}}]});c=await call('/cart.js');}}else{const updates={};c.items.filter(isService).forEach(i=>updates[i.key]=0);if(Object.keys(updates).length)c=await call('/cart/update.js',{updates});}return c;});});








form?.addEventListener('submit',async e=>{e.preventDefault();if(busy)return;const n=Math.max(1,Math.min(99,Number(qty.value)||1));qty.value=n;let added=false;await run(async()=>{await call('/cart/add.js',{items:[{id:cfg.variant,quantity:n,properties:{'Included gifts':'90 Day Personal Treatment Plan; Luxury Charging Case; eBook: Stenosis & Core Reset'}}]});added=true;return call('/cart.js');});if(added)openDialog(drawer);});








let startX=0;$('.arx-main-image')?.addEventListener('touchstart',e=>{startX=e.changedTouches[0].clientX;},{passive:true});$('.arx-main-image')?.addEventListener('touchend',e=>{const delta=e.changedTouches[0].clientX-startX;if(Math.abs(delta)<45)return;const a=$$('[data-arx-image]'),i=a.findIndex(b=>b.getAttribute('aria-pressed')==='true');a[(i+(delta<0?1:-1)+a.length)%a.length].click();},{passive:true});








function clock(){const now=Date.now(),day=86400000,offset=7*3600000;let secs=Math.floor((Math.floor((now-offset)/day)*day+day+offset-now)/1000);const h=Math.floor(secs/3600),m=Math.floor(secs%3600/60),s=secs%60;$$('[data-arx-clock]').forEach(e=>e.textContent=[h,m,s].map(n=>String(n).padStart(2,'0')).join(':'));}clock();setInterval(clock,1000);window.addEventListener('scroll',sticky,{passive:true});window.addEventListener('resize',sticky);sticky();call('/cart.js').then(c=>{cart=c;$$('[data-arx-count]').forEach(e=>e.textContent=c.items.filter(i=>!isService(i)).reduce((n,i)=>n+i.quantity,0));}).catch(()=>{});








const attribution=new URLSearchParams(location.search);$$('a[href*="'+cfg.handle+'"]').forEach(a=>{const u=new URL(a.href,location.origin);for(const [k,v]of attribution)if(/^(utm_|gclid|fbclid|ttclid|msclkid)/.test(k))u.searchParams.set(k,v);a.href=u.href;});








if(matchMedia('(prefers-reduced-motion: reduce)').matches)$$('video').forEach(v=>v.pause());








})();









(()=>{document.querySelectorAll('video').forEach(v=>{const b=document.createElement('button');b.type='button';b.className='arx-sound-button';b.textContent='Play with sound';b.setAttribute('aria-pressed','false');v.insertAdjacentElement('afterend',b);b.addEventListener('click',()=>{const on=v.muted;v.dataset.arxSound=String(on);v.muted=!on;v.defaultMuted=!on;if(on){v.removeAttribute('muted');v.volume=1;v.controls=true;v.play().catch(()=>{})}b.textContent=on?'Mute sound':'Play with sound';b.setAttribute('aria-pressed',String(on))})})})();
